import React from "react";
import { useLocation } from "react-router-dom";

import ToolLayout from "../ToolLayout";
import ProjectDiagnosticTool from "./ProjectDiagnosticTool";
import { getProjectDiagnosticContent } from "./projectDiagnosticContent";

/**
 * ProjectDiagnosticPage
 *
 * Standalone, SEO-indexable page wrapper for the Project Diagnostic tool.
 *
 * Example URL:
 * /tools/project-diagnostic?category=roofing
 */
const ProjectDiagnosticPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const category = params.get("category") || undefined;
  const zipCode = params.get("zip") || location.state?.zip || "";
  const diagnosticContent = getProjectDiagnosticContent(category);

  return (
    <ToolLayout
      title={diagnosticContent.title}
      description={diagnosticContent.description}
    >
      <ProjectDiagnosticTool category={category} zipCodeFromUrl={zipCode} />
    </ToolLayout>
  );
};

export default ProjectDiagnosticPage;
